import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Config for the clear button. `labelText` is used for `aria-label`; `onClick` clears the input */
  clearButton: PropTypes.shape({
    labelText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }).isRequired,
  /** Unique identifier for the input field and label association */
  id: PropTypes.string.isRequired,
  /** Visible and accessible label for the search input */
  label: PropTypes.string.isRequired,
  /** Callback fired when the input value changes. Receives the event object. */
  onChange: PropTypes.func.isRequired,
  /** Config for the search button. `labelText` is used for `aria-label`; `onClick` submits search. */
  searchButton: PropTypes.shape({
    labelText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }).isRequired,
  /** Sets the browser's autocomplete behavior for the input (e.g., `on`, `off`) */
  autoComplete: PropTypes.string,
  /** Name attribute for the input element */
  name: PropTypes.string,
  /** Current value of the search input */
  value: PropTypes.string
};
function SearchInputField(_ref) {
  var autoComplete = _ref.autoComplete,
    clearButton = _ref.clearButton,
    id = _ref.id,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    searchButton = _ref.searchButton,
    value = _ref.value;
  var clearButtonLabelText = clearButton.labelText,
    clearButtonOnClick = clearButton.onClick;
  var searchButtonLabelText = searchButton.labelText,
    searchButtonOnClick = searchButton.onClick;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "search-input-field",
    "data-testid": "search-input-field"
  }, /*#__PURE__*/React__default.createElement("input", {
    autoComplete: autoComplete,
    id: id,
    name: name,
    onChange: onChange,
    placeholder: label,
    type: "search",
    value: value
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "float-label",
    htmlFor: id
  }, label), value ? /*#__PURE__*/React__default.createElement("button", {
    "aria-label": clearButtonLabelText,
    className: "input-field-action-button clear-button show-clear-button",
    "data-icon": "close-circle",
    onClick: clearButtonOnClick,
    type: "button"
  }) : null, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": searchButtonLabelText,
    onClick: searchButtonOnClick,
    className: "input-field-action-button search-button",
    "data-icon": "search",
    type: "button"
  }));
}
SearchInputField.propTypes = propTypes;

export { SearchInputField as default };
//# sourceMappingURL=SearchInputField.js.map
